import axios from "axios";
import Vue from "vue";
const getDefaultSelectedBlacklistUser = () => {
  return {
    discountPackagePurchaseIds: [],
    subscriptionPurchaseIds: [],
    penalties: [],
    citizenshipNo: null,
    reportImage: null,
    blackListEndDate: null,
    addUnlimitedBlackList: false,
    reasonMessage: null,
    manualEndPrice: null,
    manualEndPaymentMethod: "CASH",
    sendSmsForRemoveInBlackList: false,
    sendSms: false,
    manualEndReason: null,
    provisionNo: null,
    firstName: null,
    lastName: null,
    customer: {},
    phoneInformation: {
      countryCode: "",
      phoneNumber: "",
      isValid: true,
      props: {
        preferredCountries: ["TR"],
      },
      phoneNumberCountryObject: {
        name: "Turkey (Türkiye)",
        iso2: "TR",
        dialCode: "90",
      },
      telInputOptions: {
        autocomplete: "on",
        autofocus: false,
        "aria-describedby": "telephone-input",
        maxlength: 15,
        name: "telephone",
        tabindex: 0,
        type: "tel",
        placeholder: null,
      },
    },
    phoneCountryCode: 90,
    phoneAreaCode: 0,
    phoneNumber: null,
  };
};

export default {
  state: () => ({
    selectedBlacklistUser: getDefaultSelectedBlacklistUser(),
  }),

  mutations: {
    setSelectedBlacklistUser(state, selectedBlacklistUser) {
      Vue.set(state, "selectedBlacklistUser", selectedBlacklistUser);
    },
    setDefaultSelectedBlacklistUser(state) {
      Vue.set(state, "selectedBlacklistUser", getDefaultSelectedBlacklistUser());
    },
  },
  actions: {
    loadAllBlacklist: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/entity")
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    addOrUpdateCustomerInBlacklist: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/blacklist/entity", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    searchBlacklist: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/blacklist/search", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getPenalties: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist-penalties")
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getBlacklistHistory: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/history/" + request.id)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserInformationInBlacklist: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/entity/" + request.id)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendToApprovalBlacklist: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/sendToApproval/" + request.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    publishBlacklist: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/publish/" + request.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    rejectBlacklist: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/blacklist/reject/" + request.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedBlacklistUser: (state) => {
      return state.selectedBlacklistUser;
    },
  },
};
